import {generateAsyncActionCreators} from '../core/reduxUtils';

const getLandingPageInfoActionCreators = generateAsyncActionCreators(
  'GET_LANDING_PAGE_INFO',
  (id, platform, params) => ({
    id,
    platform,
    params,
  }),
);

const getCategoryLandingPageInfoActionCreators = generateAsyncActionCreators(
  'GET_CATEGORY_LANDING_PAGE_INFO',
  (categoryId, platform, isBot, params) => ({
    categoryId,
    platform,
    isBot,
    params,
  }),
);

const actionCreators = {
  getLandingPageInfo: {
    ...getLandingPageInfoActionCreators,
  },
  getCategoryLandingPageInfo: {
    ...getCategoryLandingPageInfoActionCreators,
  },
};

export {
  actionCreators,
  getLandingPageInfoActionCreators,
  getCategoryLandingPageInfoActionCreators,
};
